import { API_PREFIX } from '@/config/api'
import type {
    PrintTemplateCreateModel,
    PrintTemplateModel,
    PrintTemplateUpdateModel
} from '@/types/models/PrintTemplateModel'
import {
    GET_RESPONSE_TYPE_BLOB_REQUEST,
    MULTIPART_FORMDATA_REQUEST
} from '@rfc/rfc-components-library/config'
import { api } from '@rfc/rfc-components-library/helpers'
import type { PaginationDataType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'
import type { AxiosResponse } from 'axios'

const TEMPLATES_PREFIX = `${API_PREFIX}/templates`

export type TemplateFilters = {
    organization_id?: number
}

const templatesApi = {
    getTemplates: (
        params?: Partial<PaginationType & TemplateFilters>
    ): Promise<PaginationDataType<PrintTemplateModel[]>> =>
        api.get(`${TEMPLATES_PREFIX}${buildQueryUrl(params)}`).then(res => res.data),

    getTemplate: (id: number): Promise<PrintTemplateModel> =>
        api.get(`${TEMPLATES_PREFIX}/${id}`).then(res => res.data),

    createTemplate: (
        data: PrintTemplateCreateModel
    ): Promise<AxiosResponse<PrintTemplateModel>> => {
        const formData = new FormData()
        formData.append('name', data.name)
        formData.append('type', data.type)
        formData.append('file', data.file)
        return api
            .post(TEMPLATES_PREFIX, formData, MULTIPART_FORMDATA_REQUEST)
            .then(res => res.data)
    },

    updateTemplate: (id: number, data: PrintTemplateUpdateModel): Promise<PrintTemplateModel> => {
        const formData = new FormData()
        formData.append('name', data.name)
        formData.append('type', data.type)
        if (data.file) formData.append('file', data.file)
        return api
            .post(`${TEMPLATES_PREFIX}/${id}?_method=PUT`, formData, MULTIPART_FORMDATA_REQUEST)
            .then(res => res.data)
    },

    deleteTemplate: (id: number): Promise<void> =>
        api.delete(`${TEMPLATES_PREFIX}/${id}`).then(res => res.data),

    downloadTemplate: (id: number): Promise<Blob> =>
        api
            .get(`${TEMPLATES_PREFIX}/${id}/download`, GET_RESPONSE_TYPE_BLOB_REQUEST)
            .then(res => res.data)
}

export default templatesApi
